const metrics = {
  navBarHeight: 56,
};

export default metrics;
